import React, { useState, useContext, useEffect, useRef } from "react";
import logo from "../Assets/fab hub logo (tm).png";
import { backend_url } from "../../App";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

const OrderPopup = ({
  showPopup,
  closePopup,
  product,
  selectedSize,
  count,
  currency,
  price,
}) => {
  const [step, setStep] = useState(1);
  const [promoCode, setPromoCode] = useState("");
  const [promoError, setPromoError] = useState("");
  const [appliedPromo, setAppliedPromo] = useState(null);
  const discountPercentage = product.new_price;
  const [loading, setLoading] = useState(false);
  const [userInfo, setUserInfo] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    address: "",
    city: "",
    pincode: "",
    state: "",
    country: "",
  });

  const subtotal = Number((count * price).toFixed(2));
  const discountPercent = appliedPromo?.discount || 0;
  const discountAmount = Number(
    ((subtotal * discountPercent) / 100).toFixed(2)
  );
  const shipping = 1; // Flat rate
  const gst = Number(
    ((subtotal - discountAmount + shipping) * 0.01).toFixed(2)
  );
  const finalTotalPrice = Number(
    (subtotal - discountAmount + shipping + gst).toFixed(2)
  );

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const token = localStorage.getItem("auth-token"); // match your existing login flow
        if (!token) return; // if not logged in, skip prefill

        const res = await fetch(`${backend_url}/getuserdetails`, {
          headers: { "auth-token": token },
        });

        const data = await res.json();
        if (data.success && data.user) {
          setUserInfo({
            userId: data.user.userId,
            name: data.user.name || "",
            email: data.user.email || "",
            phoneNumber: data.user.phoneNumber || "",
            address: data.user.address || "",
            city: data.user.city || "",
            pincode: data.user.pincode || "",
            state: data.user.state || "",
            country: data.user.country || "",
          });
        }
      } catch (err) {
        console.error("Error fetching user details in order popup", err);
      }
    };

    if (showPopup) {
      fetchUserDetails();
    }
  }, [showPopup]);

  const handleOrderNext = () => {
    if (
      !userInfo.name ||
      !userInfo.email ||
      !userInfo.phoneNumber ||
      !userInfo.address ||
      !userInfo.pincode ||
      !userInfo.city ||
      !userInfo.state ||
      !userInfo.country
    ) {
      toast.error("Please fill all required fields!");
      return;
    }

    const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userInfo.email);
    const isValidPhone = /^\d{10}$/.test(userInfo.phoneNumber);

    if (!isValidEmail) {
      toast.error("Invalid email");
      return;
    }
    if (!isValidPhone) {
      toast.error("Phone number must be exactly 10 digits.");
      return;
    }
    setStep(2);
  };

  const handleNext = () => {

     if (
      !userInfo.name ||
      !userInfo.email ||
      !userInfo.phoneNumber ||
      !userInfo.address ||
      !userInfo.pincode ||
      !userInfo.city ||
      !userInfo.state ||
      !userInfo.country
    ) {
      toast.error("Please fill all required fields!");
      return;
    }

    const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userInfo.email);
    const isValidPhone = /^\d{10}$/.test(userInfo.phoneNumber);

    if (!isValidEmail) {
      toast.error("Invalid email");
      return;
    }
    if (!isValidPhone) {
      toast.error("Phone number must be exactly 10 digits.");
      return;
    }

    
    handleOrder();
  };


  const applyPromoCode = async () => {
    if (!promoCode.trim()) {
      setPromoError("Please enter a promo code");
      return;
    }

    try {
      const res = await fetch(`${backend_url}/api/checkpromocode`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ promoCode: promoCode.trim() }),
      });

      const data = await res.json();

      if (data.success) {
        setAppliedPromo({
          promoCode: promoCode.trim(),
          discount: data.discount,
        });
        setPromoError("");
        toast.success(`Promo applied: ${data.discount}% off`);
      } else {
        setAppliedPromo(null);
        setPromoError(data.message || "Invalid promo code");
      }
    } catch (err) {
      setPromoError("Something went wrong");
    }
  };

  // const handleOrder = async () => {
  //   try {
  //     setStep(3);
  //     setLoading(true);
  //     const pricePerUnit =
  //       (product.old_price * (100 - discountPercentage)) / 100;

  //     // Apply promo discount if available
  //     const promoDiscount = appliedPromo ? appliedPromo.discount : 0;
  //     const totalBeforeDiscount = pricePerUnit * count;
  //     const discountAmount = (totalBeforeDiscount * promoDiscount) / 100;
  //     const finalTotal = totalBeforeDiscount - discountAmount;

  //     const orderData = {
  //       userId: userInfo.userId,
  //       productId: product._id,
  //       name: userInfo.name || "N/A",
  //       phoneNumber: userInfo.phoneNumber || 1234567890,
  //       address: userInfo.address,
  //       email: userInfo.email,
  //       city: userInfo.city,
  //       pincode: userInfo.pincode,
  //       state: userInfo.state,
  //       country: userInfo.country,
  //       size: "None",
  //       quantity: count,
  //       pricePerUnit: pricePerUnit.toFixed(2),
  //       totalPrice: finalTotal.toFixed(2),
  //       status: "Pending",
  //     };
  //     const response = await axios.post(
  //       `${backend_url}/create-order`,
  //       orderData
  //     );
  //     toast.success("Order placed successfully!");
  //   } catch (error) {
  //     console.error("Error placing order:", error);
  //     toast.error("Failed to place order.");
  //   } finally {
  //     setLoading(false); // ✅ Stop loading
  //   }
  // };

  const handleOrder = async () => {
    try {

      const pricePerUnit =
        (product.old_price * (100 - discountPercentage)) / 100;

      const promoDiscount = appliedPromo ? appliedPromo.discount : 0;

      const totalBeforeDiscount = pricePerUnit * count;

      const discountAmount = (totalBeforeDiscount * promoDiscount) / 100;

      const shippingCharges = 1;

      const gstAmount = Number(
        (
          (totalBeforeDiscount - discountAmount + shippingCharges) *
          0.01
        ).toFixed(2)
      );

      const finalTotal = Number(
        (
          totalBeforeDiscount -
          discountAmount +
          shippingCharges +
          gstAmount
        ).toFixed(2)
      );

      const orderData = {
        userId: userInfo.userId,
        productId: product._id,
        name: userInfo.name || "N/A",
        phoneNumber: userInfo.phoneNumber,
        address: userInfo.address,
        email: userInfo.email,
        city: userInfo.city,
        pincode: userInfo.pincode,
        state: userInfo.state,
        country: userInfo.country,
        size: selectedSize || "None",
        quantity: count,
        pricePerUnit: pricePerUnit.toFixed(2),
        totalPrice: finalTotal.toFixed(2),
      };

      const { data } = await axios.post(
        `${backend_url}/create-order`,
        orderData
      );

      if (data.success) {
        const { razorpayOrder } = data;

        const options = {
          key: "rzp_live_RKAmIJLBB82iLJ",
          amount: razorpayOrder.amount,
          currency: razorpayOrder.currency,
          name: "AavryaaFabhub",
          description: "Order Payment",
          image: logo,
          order_id: razorpayOrder.id,
          handler: async function (response) {
            try {
              const res = await axios.post(`${backend_url}/verify-payment`, {
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
              });

              if (res.data.success) {
                toast.success("Payment successful and order placed!");
                setStep(3);
              } else {
                toast.error("Payment verification failed");
                setStep(2);
              }
            } catch (err) {
              console.error("Error verifying payment:", err);
              toast.error("Error during payment verification");
              setStep(2);
            } finally {
              setLoading(false);
            }
          },
          prefill: {
            name: userInfo.name,
            email: userInfo.email,
            contact: userInfo.phoneNumber,
          },
          theme: { color: "#A565E9" },
        };

        const rzp = new window.Razorpay(options);
        rzp.open();
      } else {
        toast.error("Failed to initiate order");
      }
    } catch (error) {
      console.error("Error in handleOrder:", error);
      toast.error("Failed to place order.");
    } finally {
      setLoading(false);
    }
  };

  const indianStates = [
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
  ];

  const handleOrderComplete = () => {
    setStep(3);
    closePopup();
    window.location.reload();
  };

  const popupRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        closePopup(); // 👈 Close when clicking outside
      }
    };

    if (showPopup) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showPopup, closePopup]);

  if (!showPopup) return null;

  const finTotalalPrice = appliedPromo
    ? count * price - (count * price * appliedPromo.discount) / 100
    : count * price;

  // return (
  //   <>
  //     <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
  //       <div
  //         className="bg-white rounded-lg shadow-lg w-full max-w-md mx-auto relative max-h-[90vh] overflow-y-auto"
  //         ref={popupRef}
  //       >
  //         {/* Header Container */}
  //         <div className="relative bg-gradient-to-b from-purple-50 to-white rounded-t-lg p-4 sm:p-6 pb-6 sm:pb-8 border-b border-purple-100">
  //           {/* Close Button - Responsive positioning */}
  //           <button
  //             onClick={closePopup}
  //             className="absolute top-3 right-3 sm:top-4 sm:right-4 w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center rounded-full bg-white text-gray-500 hover:text-purple-600 hover:bg-purple-50 transition-all duration-200 shadow-sm hover:shadow-md border border-gray-200 hover:border-purple-200 z-50 focus:outline-none focus:ring-2 focus:ring-purple-300"
  //             aria-label="Close"
  //           >
  //             <svg
  //               xmlns="http://www.w3.org/2000/svg"
  //               className="h-4 w-4 sm:h-5 sm:w-5"
  //               viewBox="0 0 20 20"
  //               fill="currentColor"
  //             >
  //               <path
  //                 fillRule="evenodd"
  //                 d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
  //                 clipRule="evenodd"
  //               />
  //             </svg>
  //           </button>

  //           {/* Logo - Responsive sizing */}
  //           <div className="flex justify-center mb-4 sm:mb-6 transform hover:scale-105 transition-transform duration-300 focus-within:scale-105 outline-none">
  //             <img
  //               crossOrigin="anonymous"
  //               src={logo}
  //               alt="Logo"
  //               className=" drop-shadow-md hover:drop-shadow-lg transition-all duration-300 w-32"
  //               tabIndex={-1}
  //             />
  //           </div>

  //           {/* Stepper - Responsive adjustments */}
  //           <div className="relative mb-6 sm:mb-8 px-2 sm:px-0">
  //             <div
  //               className="absolute top-1/2 left-0 w-full h-1.5 sm:h-2 bg-gray-200 rounded-full -translate-y-1/2"
  //               aria-hidden="true"
  //             >
  //               <div
  //                 className="h-full bg-gradient-to-r from-purple-400 to-purple-600 rounded-full transition-all duration-500 ease-out shadow-purple-200 shadow-inner"
  //                 style={{ width: `${(step - 1) * 50}%` }}
  //                 role="progressbar"
  //                 aria-valuenow={(step - 1) * 50}
  //                 aria-valuemin="0"
  //                 aria-valuemax="100"
  //               />
  //             </div>

  //             <ol className="flex justify-between relative z-10">
  //               {[
  //                 { number: 1, icon: "🛒", label: "Cart" },
  //                 { number: 2, icon: "📝", label: "Details" },
  //                 { number: 3, icon: "✅", label: "Confirm" },
  //               ].map((item) => (
  //                 <li
  //                   key={item.number}
  //                   className="flex flex-col items-center"
  //                   aria-current={step === item.number ? "step" : undefined}
  //                 >
  //                   <div
  //                     className={`w-8 h-8 sm:w-10 sm:h-10 rounded-full flex items-center justify-center text-base sm:text-lg font-semibold transition-all duration-300 ${
  //                       step >= item.number
  //                         ? "bg-purple-600 text-white shadow-purple-400"
  //                         : "bg-gray-100 text-gray-400"
  //                     } ${
  //                       step === item.number
  //                         ? "animate-pulse-once ring-2 ring-purple-300"
  //                         : ""
  //                     } focus:outline-none focus:ring-2 focus:ring-purple-300`}
  //                     tabIndex={0}
  //                   >
  //                     <span aria-hidden="true">{item.icon}</span>
  //                     <span className="sr-only">
  //                       Step {item.number}: {item.label}
  //                     </span>
  //                   </div>
  //                   <span
  //                     className={`text-[10px] sm:text-xs mt-1 sm:mt-2 font-medium ${
  //                       step >= item.number
  //                         ? "text-purple-600"
  //                         : "text-gray-400"
  //                     }`}
  //                   >
  //                     {item.label}
  //                   </span>
  //                 </li>
  //               ))}
  //             </ol>
  //           </div>
  //         </div>

  //         {/* Content Area */}
  //         <div className="p-4 sm:p-6">
  //           {/* Step 1 - User Information */}
  //           {step === 1 && (
  //             <div className="space-y-4">
  //               <div className="bg-gradient-to-r from-blue-500 to-purple-600 p-4 sm:p-6 rounded-lg">
  //                 <h2 className="text-xl sm:text-2xl font-bold text-white">
  //                   User Information
  //                 </h2>
  //                 <p className="text-blue-100 text-sm sm:text-base">
  //                   Please enter your details to proceed
  //                 </p>
  //               </div>

  //               <div className="space-y-4">
  //                 {/* Promo code section */}
  //                 <div className="flex flex-col sm:flex-row gap-2">
  //                   <input
  //                     type="text"
  //                     placeholder="Enter Promo Code"
  //                     value={promoCode}
  //                     onChange={(e) => setPromoCode(e.target.value)}
  //                     className="flex-1 border border-gray-300 p-2 sm:p-3 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all text-sm sm:text-base"
  //                   />
  //                   <button
  //                     onClick={applyPromoCode}
  //                     className="bg-gradient-to-r from-green-500 to-emerald-600 text-white px-4 sm:px-6 py-2 sm:py-3 rounded-lg hover:from-green-600 hover:to-emerald-700 transition-all shadow-md hover:shadow-lg flex items-center justify-center text-sm sm:text-base"
  //                   >
  //                     <svg
  //                       xmlns="http://www.w3.org/2000/svg"
  //                       className="h-4 w-4 sm:h-5 sm:w-5 mr-1"
  //                       viewBox="0 0 20 20"
  //                       fill="currentColor"
  //                     >
  //                       <path
  //                         fillRule="evenodd"
  //                         d="M5 2a2 2 0 00-2 2v14l3.5-2 3.5 2 3.5-2 3.5 2V4a2 2 0 00-2-2H5zm4.707 5.707a1 1 0 00-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L8.414 10l1.293-1.293zm4 0a1 1 0 010 1.414L13.586 10l1.293 1.293a1 1 0 01-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0z"
  //                         clipRule="evenodd"
  //                       />
  //                     </svg>
  //                     Apply
  //                   </button>
  //                 </div>
  //                 {promoError && (
  //                   <p className="text-red-500 text-xs sm:text-sm font-medium px-2">
  //                     {promoError}
  //                   </p>
  //                 )}
  //                 {/* Form fields */}
  //                 <div className="space-y-3 sm:space-y-4">
  //                   {[
  //                     {
  //                       label: "Full Name",
  //                       type: "text",
  //                       value: userInfo.name,
  //                       placeholder: "John Doe",
  //                       onChange: (e) =>
  //                         setUserInfo({ ...userInfo, name: e.target.value }),
  //                     },
  //                     {
  //                       label: "Email",
  //                       type: "email",
  //                       value: userInfo.email,
  //                       placeholder: "john@example.com",
  //                       onChange: (e) =>
  //                         setUserInfo({ ...userInfo, email: e.target.value }),
  //                     },
  //                     {
  //                       label: "Phone Number",
  //                       type: "tel",
  //                       value: userInfo.phoneNumber,
  //                       placeholder: "1234567890",
  //                       maxLength: 10,
  //                       minLength: 10,
  //                       onChange: (e) => {
  //                         const inputVal = e.target.value;
  //                         if (/^\d*$/.test(inputVal) && inputVal.length <= 10) {
  //                           setUserInfo({ ...userInfo, phoneNumber: inputVal });
  //                         }
  //                       },
  //                     },
  //                     {
  //                       label: "Address",
  //                       type: "text",
  //                       value: userInfo.address,
  //                       placeholder: "123 Main St",
  //                       onChange: (e) =>
  //                         setUserInfo({ ...userInfo, address: e.target.value }),
  //                     },
  //                   ].map((field, index) => (
  //                     <div key={index}>
  //                       <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
  //                         {field.label}
  //                       </label>
  //                       <input
  //                         type={field.type}
  //                         placeholder={field.placeholder}
  //                         value={field.value}
  //                         onChange={field.onChange}
  //                         className="w-full border border-gray-300 p-2 sm:p-3 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all text-sm sm:text-base"
  //                       />
  //                     </div>
  //                   ))}

  //                   {/* Grid fields */}
  //                   <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
  //                     {/* City */}
  //                     <div>
  //                       <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
  //                         City
  //                       </label>
  //                       <input
  //                         type="text"
  //                         placeholder="New York"
  //                         value={userInfo.city}
  //                         onChange={(e) =>
  //                           setUserInfo({ ...userInfo, city: e.target.value })
  //                         }
  //                         className="w-full border border-gray-300 p-2 sm:p-3 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all text-sm sm:text-base"
  //                       />
  //                     </div>

  //                     {/* Postal Code */}
  //                     <div>
  //                       <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
  //                         Postal Code
  //                       </label>
  //                       <input
  //                         type="text"
  //                         placeholder="10001"
  //                         value={userInfo.pincode}
  //                         onChange={(e) =>
  //                           setUserInfo({
  //                             ...userInfo,
  //                             pincode: e.target.value
  //                               .replace(/\D/g, "")
  //                               .slice(0, 6),
  //                           })
  //                         }
  //                         pattern="\d{4,6}"
  //                         title="Please enter a valid postal code (4-6 digits)"
  //                         required
  //                         className="w-full border border-gray-300 p-2 sm:p-3 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all text-sm sm:text-base"
  //                       />
  //                     </div>

  //                     {/* Country */}
  //                     <div>
  //                       <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
  //                         Country
  //                       </label>
  //                       <select
  //                         value={userInfo.country}
  //                         onChange={(e) =>
  //                           setUserInfo({
  //                             ...userInfo,
  //                             country: e.target.value,
  //                             state: "",
  //                           })
  //                         }
  //                         className="w-full border border-gray-300 p-2 sm:p-3 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all text-sm sm:text-base"
  //                       >
  //                         <option value="">Select Country</option>
  //                         <option value="India">India</option>
  //                         <option value="Other">Other</option>
  //                       </select>
  //                     </div>

  //                     {/* State (Only if India is selected) */}
  //                     {userInfo.country === "India" && (
  //                       <div>
  //                         <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
  //                           State
  //                         </label>
  //                         <select
  //                           value={userInfo.state}
  //                           onChange={(e) =>
  //                             setUserInfo({
  //                               ...userInfo,
  //                               state: e.target.value,
  //                             })
  //                           }
  //                           className="w-full border border-gray-300 p-2 sm:p-3 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all text-sm sm:text-base"
  //                         >
  //                           <option value="">Select State</option>
  //                           {indianStates.map((state, idx) => (
  //                             <option key={idx} value={state}>
  //                               {state}
  //                             </option>
  //                           ))}
  //                         </select>
  //                       </div>
  //                     )}
  //                   </div>
  //                 </div>

  //                 {/* Next button */}
  //                 <button
  //                   onClick={handleOrderNext}
  //                   className="w-full bg-gradient-to-r from-purple-500 to-blue-600 text-white py-2 sm:py-3 px-4 sm:px-6 rounded-lg font-medium hover:from-purple-600 hover:to-blue-700 transition-all shadow-md hover:shadow-lg mt-4 sm:mt-6 flex items-center justify-center text-sm sm:text-base"
  //                 >
  //                   Continue to Payment
  //                   <svg
  //                     xmlns="http://www.w3.org/2000/svg"
  //                     className="h-4 w-4 sm:h-5 sm:w-5 ml-2"
  //                     viewBox="0 0 20 20"
  //                     fill="currentColor"
  //                   >
  //                     <path
  //                       fillRule="evenodd"
  //                       d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
  //                       clipRule="evenodd"
  //                     />
  //                   </svg>
  //                 </button>
  //               </div>
  //             </div>
  //           )}

  //           {/* Step 2 - Order Summary */}
  //           {step === 2 && (
  //             <div className="space-y-6">
  //               <div className="bg-gradient-to-r from-purple-500 to-indigo-600 p-4 sm:p-6 rounded-t-lg">
  //                 <h2 className="text-xl sm:text-2xl font-bold text-white">
  //                   Order Summary
  //                 </h2>
  //                 <p className="text-purple-100 text-sm sm:text-base">
  //                   Review your purchase before confirming
  //                 </p>
  //               </div>

  //               {/* Product List */}
  //               <div className="border border-gray-200 rounded-lg divide-y divide-gray-200 max-h-60 overflow-y-auto">
  //                 {product ? (
  //                   <div className="flex justify-between items-center p-4 hover:bg-gray-50 transition-colors">
  //                     <div className="flex items-center gap-3">
  //                       <img
  //                         crossOrigin="anonymous"
  //                         src={product.images[0] || "/placeholder.png"}
  //                         alt={product.name}
  //                         className="w-14 h-14 object-cover rounded-md border"
  //                       />
  //                       <div>
  //                         <p className="font-medium">{product.name}</p>
  //                         <p className="text-sm text-gray-500">Qty: {count}</p>
  //                       </div>
  //                     </div>
  //                     <p className="font-medium">
  //                       {currency}
  //                       {Number(price).toFixed(2)}
  //                     </p>
  //                   </div>
  //                 ) : (
  //                   <p className="p-4 text-gray-500">No products to show</p>
  //                 )}
  //               </div>

  //               {/* Billing Summary */}
  //               <div className="border border-gray-200 rounded-lg shadow p-4 space-y-4">
  //                 {/* Subtotal */}
  //                 <div className="flex justify-between items-center">
  //                   <span className="text-gray-700 font-medium">Subtotal:</span>
  //                   <span className="font-medium">
  //                     {currency}
  //                     {(count * price).toFixed(2)}
  //                   </span>
  //                 </div>

  //                 {/* Promo Discount */}
  //                 {discountPercent > 0 && (
  //                   <div className="flex justify-between items-center text-green-700 font-medium">
  //                     <span>Promo Discount ({discountPercent}%):</span>
  //                     <span>
  //                       - {currency}
  //                       {discountAmount.toFixed(2)}
  //                     </span>
  //                   </div>
  //                 )}
  //                 {/* Shipping Charges */}
  //                 <div className="flex justify-between items-center text-gray-700 font-medium">
  //                   <span>Shipping Charges:</span>
  //                   <span>
  //                     {currency}
  //                     {shipping.toFixed(2)}
  //                   </span>
  //                 </div>

  //                 {/* GST (e.g., 18%) */}
  //                 <div className="flex justify-between items-center text-gray-700 font-medium">
  //                   <span>GST (18%):</span>
  //                   <span>
  //                     {currency}
  //                     {gst.toFixed(2)}
  //                   </span>
  //                 </div>

  //                 {/* Divider */}
  //                 <div className="border-t border-gray-300 my-2"></div>

  //                 {/* Final Total */}
  //                 <div className="flex justify-between items-center">
  //                   <span className="text-gray-900 font-bold text-lg">
  //                     Grand Total:
  //                   </span>
  //                   <span className="text-purple-600 font-bold text-lg">
  //                     {currency}
  //                     {finalTotalPrice.toFixed(2)}
  //                   </span>
  //                 </div>
  //               </div>

  //               {/* Navigation Buttons */}
  //               <div className="flex gap-4">
  //                 <button
  //                   onClick={handleBack}
  //                   className="flex-1 py-3 px-6 rounded-lg border border-purple-500 text-purple-500 font-medium hover:bg-purple-50 transition-colors"
  //                 >
  //                   Back
  //                 </button>

  //                 <button
  //                   onClick={handleNext}
  //                   className="flex-1 py-3 px-6 rounded-lg bg-gradient-to-r from-purple-500 to-indigo-600 text-white font-medium hover:from-purple-600 hover:to-indigo-700 transition-all shadow-md hover:shadow-lg"
  //                 >
  //                   Confirm Order
  //                 </button>
  //               </div>
  //             </div>
  //           )}

  //           {/* Step 3 - Confirmation */}
  //           {step === 3 && (
  //             <div>
  //               {loading ? (
  //                 <div className="flex items-center justify-center gap-3">
  //                   {/* Spinner */}
  //                   <span className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin shadow-md"></span>

  //                   {/* Text */}
  //                   <span className="text-sm font-semibold text-purple-800 tracking-wide animate-pulse">
  //                     Placing Order...
  //                   </span>
  //                 </div>
  //               ) : (
  //                 <div className="max-w-md mx-auto bg-white rounded-2xl shadow-sm overflow-hidden p-6 sm:p-8 text-center animate-fade-in">
  //                   <div className="relative w-16 h-16 sm:w-24 sm:h-24 mx-auto mb-4 sm:mb-6">
  //                     <div className="absolute inset-0 bg-green-100 rounded-full animate-scale-in"></div>
  //                     <svg
  //                       className="absolute inset-0 m-auto w-10 h-10 sm:w-16 sm:h-16 text-green-500 animate-checkmark"
  //                       xmlns="http://www.w3.org/2000/svg"
  //                       viewBox="0 0 24 24"
  //                       fill="none"
  //                       stroke="currentColor"
  //                       strokeWidth="2"
  //                       strokeLinecap="round"
  //                       strokeLinejoin="round"
  //                     >
  //                       <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
  //                       <polyline points="22 4 12 14.01 9 11.01"></polyline>
  //                     </svg>
  //                   </div>

  //                   <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2 sm:mb-3 flex items-center justify-center">
  //                     Order Confirmed!
  //                     <span className="ml-2 animate-bounce">🎉</span>
  //                   </h2>

  //                   <p className="text-sm sm:text-lg text-gray-600 mb-4 sm:mb-6">
  //                     Your order{" "}
  //                     <span className="font-semibold text-purple-600"></span>{" "}
  //                     has been placed successfully!
  //                   </p>

  //                   <div className="bg-purple-50 rounded-lg sm:rounded-xl p-3 sm:p-4 mb-4 sm:mb-6 border border-purple-100">
  //                     <p className="text-xs sm:text-sm text-purple-800 mb-1">
  //                       We've sent a confirmation to your email
  //                     </p>
  //                     <p className="text-[10px] sm:text-xs text-purple-600">
  //                       {userInfo?.email || "your@email.com"}
  //                     </p>
  //                   </div>

  //                   <button
  //                     onClick={handleOrderComplete}
  //                     className="w-full py-2 sm:py-3 px-4 sm:px-6 bg-gradient-to-r from-purple-500 to-indigo-600 text-white font-medium rounded-lg hover:from-purple-600 hover:to-indigo-700 transition-all shadow-md hover:shadow-lg text-sm sm:text-base"
  //                   >
  //                     Close
  //                   </button>

  //                   <div className="mt-4 sm:mt-6 p-3 sm:p-4 bg-gray-50 rounded-lg border border-gray-200">
  //                     <h3 className="text-xs sm:text-sm font-medium text-gray-700 mb-1 sm:mb-2">
  //                       Order Summary
  //                     </h3>
  //                     <p className="text-[10px] sm:text-xs text-gray-500">
  //                       {product?.name || "Your item"} × {count}
  //                     </p>
  //                     <p className="text-xs sm:text-sm font-medium text-gray-800 mt-1">
  //                       Total: {currency}
  //                       {finalTotalPrice.toFixed(2)}
  //                     </p>
  //                   </div>
  //                 </div>
  //               )}
  //             </div>
  //           )}
  //         </div>
  //       </div>
  //     </div>

  //     <ToastContainer />
  //   </>
  // );

  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-start z-50 p-4">
        <div className="min-h-full w-full flex items-center justify-center">
          <div
            className="bg-white rounded-xl shadow-lg overflow-hidden w-full max-w-6xl my-8 max-h-[90vh] overflow-y-auto"
            ref={popupRef}
          >
            {/* Header */}
            <div className="bg-gradient-to-r from-purple-600 to-indigo-700 text-white p-6 flex justify-between items-center sticky top-0 z-10">
              <div className="flex items-center">
                <img
                  crossOrigin="anonymous"
                  src={logo}
                  alt="Logo"
                  className="h-10 mr-4"
                />
                
<h1 className="text-2xl font-bold">
  {step !== 3 ? "Complete Your Purchase" : "Order Confirmed!"}
</h1>
              </div>
              <button
                onClick={closePopup}
                className="text-white hover:text-purple-200 transition-colors"
                aria-label="Close"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            {/* Main Content */}
            <div className="p-6">
                {step !== 3 ? (

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                {/* Left Column - Order Summary */}

                  <div className="bg-white rounded-lg p-6">
                  <h2 className="text-xl font-bold text-purple-700 mb-4 border-b border-purple-200 pb-2">
                    Your Information
                  </h2>

                  <div className="space-y-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Full Name *
                        </label>
                        <input
                          type="text"
                          placeholder="John Doe"
                          value={userInfo.name}
                          onChange={(e) =>
                            setUserInfo({ ...userInfo, name: e.target.value })
                          }
                          className="w-full border border-gray-300 p-3 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all text-sm"
                        />
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Email *
                        </label>
                        <input
                          type="email"
                          placeholder="john@example.com"
                          value={userInfo.email}
                          onChange={(e) =>
                            setUserInfo({ ...userInfo, email: e.target.value })
                          }
                          className="w-full border border-gray-300 p-3 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all text-sm"
                        />
                      </div>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Phone Number *
                      </label>
                      <input
                        type="tel"
                        placeholder="1234567890"
                        value={userInfo.phoneNumber}
                        onChange={(e) => {
                          const inputVal = e.target.value;
                          if (/^\d*$/.test(inputVal) && inputVal.length <= 10) {
                            setUserInfo({ ...userInfo, phoneNumber: inputVal });
                          }
                        }}
                        className="w-full border border-gray-300 p-3 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all text-sm"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Address *
                      </label>
                      <input
                        type="text"
                        placeholder="123 Main St"
                        value={userInfo.address}
                        onChange={(e) =>
                          setUserInfo({ ...userInfo, address: e.target.value })
                        }
                        className="w-full border border-gray-300 p-3 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all text-sm"
                      />
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          City *
                        </label>
                        <input
                          type="text"
                          placeholder="New York"
                          value={userInfo.city}
                          onChange={(e) =>
                            setUserInfo({ ...userInfo, city: e.target.value })
                          }
                          className="w-full border border-gray-300 p-3 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all text-sm"
                        />
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Postal Code *
                        </label>
                        <input
                          type="text"
                          placeholder="10001"
                          value={userInfo.pincode}
                          onChange={(e) =>
                            setUserInfo({
                              ...userInfo,
                              pincode: e.target.value
                                .replace(/\D/g, "")
                                .slice(0, 6),
                            })
                          }
                          className="w-full border border-gray-300 p-3 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all text-sm"
                        />
                      </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Country *
                        </label>
                        <select
                          value={userInfo.country}
                          onChange={(e) =>
                            setUserInfo({
                              ...userInfo,
                              country: e.target.value,
                              state: "",
                            })
                          }
                          className="w-full border border-gray-300 p-3 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all text-sm"
                        >
                          <option value="">Select Country</option>
                          <option value="India">India</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>

                      {userInfo.country === "India" && (
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            State *
                          </label>
                          <select
                            value={userInfo.state}
                            onChange={(e) =>
                              setUserInfo({
                                ...userInfo,
                                state: e.target.value,
                              })
                            }
                            className="w-full border border-gray-300 p-3 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all text-sm"
                          >
                            <option value="">Select State</option>
                            {indianStates.map((state, idx) => (
                              <option key={idx} value={state}>
                                {state}
                              </option>
                            ))}
                          </select>
                        </div>
                      )}
                    </div>

                    {/* Confirm Order Button */}
                
                  </div>
                </div>

          
                {/* Right Column - User Information */}
                    <div className="bg-gray-50 rounded-lg p-6">
                  <h2 className="text-xl font-bold text-purple-700 mb-4 border-b border-purple-200 pb-2">
                    Order Summary
                  </h2>

  

                  {/* Product List */}
                  <div className="mb-6">
                    {product ? (
                      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center p-4 bg-white rounded-lg shadow-sm border border-purple-100 gap-4">
                        <div className="flex items-start sm:items-center gap-4 w-full sm:w-auto">
                          <img
                            crossOrigin="anonymous"
                            src={product.images[0] || "/placeholder.png"}
                            alt={product.name}
                            className="w-16 h-16 sm:w-20 sm:h-20 object-cover rounded-md border flex-shrink-0"
                          />
                          <div className="flex-1">
                            <p className="font-medium text-gray-800 text-sm sm:text-base">
                              {product.name}
                            </p>
                            <p className="text-sm text-gray-500 mt-1">
                              Quantity: {count}
                            </p>
                          </div>
                        </div>
                        <p className="font-medium text-purple-700 text-sm sm:text-base mt-2 sm:mt-0">
                          {currency}
                          {Number(price).toFixed(2)}
                        </p>
                      </div>
                    ) : (
                      <p className="p-4 text-gray-500 text-center bg-white rounded-lg">
                        No products to show
                      </p>
                    )}
                  </div>

                  {/* Billing Summary */}
                  <div className="bg-white rounded-lg shadow-sm border border-purple-100 p-5 space-y-3">
                    <h3 className="font-semibold text-gray-800 border-b border-gray-100 pb-2">
                      Order Details
                    </h3>

                    <div className="flex justify-between items-center">
                      <span className="text-gray-700">Subtotal:</span>
                      <span className="font-medium">
                        {currency}
                        {(count * price).toFixed(2)}
                      </span>
                    </div>

                    {/* Promo Code Section */}
                    <div className="border-t border-gray-100 pt-3 mt-3">
                      <div className="flex flex-col sm:flex-row gap-2 mb-2">
                        <input
                          type="text"
                          placeholder="Enter Promo Code"
                          value={promoCode}
                          onChange={(e) => setPromoCode(e.target.value)}
                          className="flex-1 border border-gray-300 p-3 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all text-sm"
                        />
                        <button
                          onClick={applyPromoCode}
                          className="bg-gradient-to-r from-green-500 to-emerald-600 text-white px-4 py-3 rounded-lg hover:from-green-600 hover:to-emerald-700 transition-all shadow-md hover:shadow-lg flex items-center justify-center text-sm whitespace-nowrap"
                        >
                          Apply
                        </button>
                      </div>
                      {promoError && (
                        <p className="text-red-500 text-sm font-medium px-2">
                          {promoError}
                        </p>
                      )}

                      {discountPercent > 0 && (
                        <div className="flex justify-between items-center text-green-700 font-medium">
                          <span>Promo Discount ({discountPercent}%):</span>
                          <span>
                            - {currency}
                            {discountAmount.toFixed(2)}
                          </span>
                        </div>
                      )}
                    </div>

                    <div className="flex justify-between items-center">
                      <span className="text-gray-700">Shipping Charges:</span>
                      <span>
                        {currency}
                        {shipping.toFixed(2)}
                      </span>
                    </div>

                    <div className="flex justify-between items-center">
                      <span className="text-gray-700">GST (18%):</span>
                      <span>
                        {currency}
                        {gst.toFixed(2)}
                      </span>
                    </div>

                    <div className="border-t border-gray-300 pt-3 mt-3">
                      <div className="flex justify-between items-center">
                        <span className="text-gray-900 font-bold text-lg">
                          Grand Total:
                        </span>
                        <span className="text-purple-700 font-bold text-lg">
                          {currency}
                          {finalTotalPrice.toFixed(2)}
                        </span>
                      </div>
                          <button
                      onClick={handleNext}
                      className="w-full bg-gradient-to-r from-purple-600 to-blue-600 text-white py-3 px-6 rounded-lg font-medium hover:from-purple-700 hover:to-blue-700 transition-all shadow-md hover:shadow-lg mt-4 flex items-center justify-center text-sm"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5 mr-2"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M5 2a2 2 0 00-2 2v14l3.5-2 3.5 2 3.5-2 3.5 2V4a2 2 0 00-2-2H5zm4.707 5.707a1 1 0 00-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L8.414 10l1.293-1.293zm4 0a1 1 0 010 1.414L13.586 10l1.293 1.293a1 1 0 01-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                      Confirm Order
                    </button>
                    </div>
                  </div>
                </div>
              </div>
          ) : (
  <div className="max-w-md mx-auto bg-white rounded-2xl shadow-sm overflow-hidden p-6 sm:p-8 text-center animate-fade-in">
    {/* Animated checkmark */}
    <div className="relative w-16 h-16 sm:w-24 sm:h-24 mx-auto mb-4 sm:mb-6">
      <div className="absolute inset-0 bg-green-100 rounded-full animate-scale-in"></div>
      <svg
        className="absolute inset-0 m-auto w-10 h-10 sm:w-16 sm:h-16 text-green-500 animate-checkmark"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
        <polyline points="22 4 12 14.01 9 11.01"></polyline>
      </svg>
    </div>

    <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2 sm:mb-3 flex items-center justify-center">
      Order Confirmed!
      <span className="ml-2 animate-bounce">🎉</span>
    </h2>

    <p className="text-sm sm:text-lg text-gray-600 mb-4 sm:mb-6">
      Your order <span className="font-semibold text-purple-600">{product?.name}</span> has been placed successfully!
    </p>

    <div className="bg-purple-50 rounded-lg sm:rounded-xl p-3 sm:p-4 mb-4 sm:mb-6 border border-purple-100">
      <p className="text-xs sm:text-sm text-purple-800 mb-1">
        We've sent a confirmation to your email
      </p>
      <p className="text-[10px] sm:text-xs text-purple-600">
        {userInfo?.email || "your@email.com"}
      </p>
    </div>

    <button
      onClick={handleOrderComplete}
      className="w-full py-2 sm:py-3 px-4 sm:px-6 bg-gradient-to-r from-purple-500 to-indigo-600 text-white font-medium rounded-lg hover:from-purple-600 hover:to-indigo-700 transition-all shadow-md hover:shadow-lg text-sm sm:text-base"
    >
      Close
    </button>

    <div className="mt-4 sm:mt-6 p-3 sm:p-4 bg-gray-50 rounded-lg border border-gray-200">
      <h3 className="text-xs sm:text-sm font-medium text-gray-700 mb-1 sm:mb-2">
        Order Summary
      </h3>
      <p className="text-[10px] sm:text-xs text-gray-500">
        {product?.name || "Your item"} × {count}
      </p>
      <p className="text-xs sm:text-sm font-medium text-gray-800 mt-1">
        Total: {currency}{finalTotalPrice.toFixed(2)}
      </p>
    </div>
  </div>
)} 
            </div>
            
         </div>
        </div>
      </div>

      <ToastContainer />
    </>
  );
};

export default OrderPopup;
